import React, { Component } from 'react'
import gql from 'graphql-tag'
import { Row, Col, Alert, Label, Table, UncontrolledTooltip, Button, Badge, Popover, PopoverBody, Input } from 'reactstrap'
import { Link } from 'react-router-dom'
import { graphql } from '@apollo/client/react/hoc'
import moment from 'moment'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

import withApolloClient from '../../withApolloClient'
import CustomInputField from '../../Drivers/Driver/Detail/DetailsNew/CustomInputField'
import toTitleCase from "../../Functions/toTitleCase"
import { BILLING_DAYS } from '../../Constants'
import RepAvatar from '../../Material/RepAvatar'
import RenderArgyleGigs from '../Components/RenderArgyleGigs'

import TransactionInfo from "../../Billing/Transactions/TransactionInfo"
import CarIssueModal from "../../Maintenance/CarIssueModal"
import DatetimeRenderer from "../../Material/DatetimeRenderer"
import DocumentModalNew from "../../Material/DocumentModal/DocumentModalNew"
import { cleanDocumentUrl } from "../../Material/DocumentModal/DocumentsListNew"
import { getStatesByCountry, getStateOptions } from '../../utils'
import { PreferredDateTimeContext } from '../../Context/PreferredDateTimeContext'
import UpdateIncidentInfo from '../Components/UpdateIncidentInfo'
import MapPicker from '../../Material/MapPicker'
import { HasPermissionsQuery } from '../../Functions/querys'
import { renderTasks, getMissingTaskCount } from '../Shared/TaskUtils'
import AddExternalSystem from '../IncidentModals/AddExternalSystem'

import './OverviewTab.css'
import RenderUberAccidents from "../Components/RenderUberAccidents"
import FieldHistoryPopover from '../Components/FieldHistoryPopover'

const IncidentDetailQuery = gql`query Incident($incidentId: ID!){
    incident(incidentId:$incidentId){
        id
        pk
        dateAdded
        incidentDate
        incidentTime
        incidentType
        notificationDate
        reportedBy
        metadata
        isArchived
        incidentState
        dmvPlate
        carOnHold
        carTotaled
        ridesharePlatform
        ridesharePeriod
        ridesharePeriodSource
        rideshareIncidentId
        responsibleParty
        source
        status
        location
        hasPoliceReport
        hasDashcamVideos
        hasOtherParties
        hasLiabilityClaim
        hasSubroClaim
        isRecordOnly
        description
        notes
        canChangeBranch
        history {
            date
            user
            comment
        }
        branch {
            id
            name
            stateCode
        }
        liabilityclaimSet {
            edges {
                node {
                    id
                    externalId
                }
            }
        }
        assignedTo {
            edges {
                node {
                    id
                    pk
                    username
                    firstName
                    lastName
                }
            }
        }
        carCondition {
            id
            pk
        }
        incidentpartySet {
            edges {
                node {
                    id
                }
            }
        }
        incidentdocumentSet {
            edges {
                node {
                    id
                    documentType{
                        id
                        name
                    }
                }
            }
        }
        damageTransaction {
            id
            pk
            dateAdded
            dynamicAmount
            notes
            linkedPaymentPlan {
                id
                resultantTransactionsSum
            }
            chargeType {
                id
                name
            }
            updates {
                edges {
                    node {
                        id
                        linkedPaymentPlan {
                            id
                            resultantTransactionsSum
                        }
                    }
                }
            }
        }
        incidentdamageSet {
            edges {
                node {
                    id
                    damage {
                        id
                        car {
                            id
                            pk
                        }
                        dateAdded
                        description: notes
                        issueDesc
                        status
                        reportedBy
                        canPickup
                        projectedCost
                        severity
                        pictures {
                            edges {
                                node {
                                    id
                                    dateAdded
                                    pictureUrl
                                    pictureType
                                    description
                                }
                            }
                        }
                        issueCategory {
                            id
                            name: category
                        }
                        vendor {
                            id
                            name
                        }
                    }
                }
            }
        }
        rental{
            id
            driver {
                id
                name
                balance 
                stage
                tlcLicense
                dmvLicense
                phone
                email
                chargeDayofweek
                currentAgreement {
                    id
                }
                paymentMethod {
                    id
                    name
                }
                branch{
                    id
                    name
                }
            }
        }
        car {
            id
            pk
            year
            color
            vin
            notes
            branch {
                id
                name
            }
            carModel {
                id
                make
                name
                groupType {
                    id
                    name
                }
            }
            plate {
                id
                dmvPlate
                fhv
            }
            activePolicy {
                id
                insurancePolicy {
                    id
                    policyNumber
                    broker {
                        id
                        name
                    }
                }
            }
        }
    }
    ridesharePlatformChoices: __type(name: "IncidentsIncidentRidesharePlatformChoices") {
        enumValues {
            name
            description
        }
    }
    ridesharePeriodChoices: __type(name: "IncidentsIncidentRidesharePeriodChoices") {
        enumValues {
            name
            description
        }
    }
    ridesharePeriodSourceChoices: __type(name: "IncidentsIncidentRidesharePeriodSourceChoices") {
        enumValues {
            name
            description
        }
    }
    responsiblePartyChoices: __type(name: "IncidentsIncidentResponsiblePartyChoices") {
        enumValues {
            name
            description
        }
    }
    sourceChoices: __type(name: "IncidentsIncidentSourceChoices") {
        enumValues {
            name
            description
        }
    }
    statusChoices: __type(name: "IncidentsIncidentStatusChoices") {
        enumValues {
            name
            description
        }
    }
    reportedByChoices: __type(name: "IncidentsIncidentReportedByChoices") {
        enumValues {
            name
            description
        }
    }
    carIssueSeverityLevels: __type(name: "CarsCarIssuesSeverityChoices") {
        enumValues {
            name
            description
        }
    }
    incidentTypeChoices: __type(name: "IncidentsIncidentIncidentTypeChoices") {
        enumValues {
            name
            description
        }
    }
    carTotaledChoices: __type(name: "IncidentsIncidentCarTotaledChoices") {
        enumValues {
            name
            description
        }
    }
    incidentNodeFieldDescriptions: __type(name: "IncidentNode") {
        fields {
           name
           description
        }
    } 
    branchOptions: allBranches(isActive:true) {
        edges {
            node {
                id
                name
            }
        }
    }
}`

const ISSUES_TABLE = [
    { id: "date_addded", name: "Date Added", sortable: true },
    { id: "issueCategory", name: "Category", sortable: false },
    { id: "status", name: "Status", sortable: false },
    { id: "projectedCost", name: "Projected Cost", sortable: false },
    { id: "severity", name: "Severity Level", sortable: false },
    { id: "canPickup", name: "Can Pickup", sortable: false },
    { id: "pictures", name: "Pictures", sortable: false },
    { id: "action", name: "Action", sortable: false },
]

const UpdateIncident = gql`
    mutation updateIncidentMutation($input: UpdateIncidentMutationInput!){
    updateIncident(input:$input){
        ok
        errors{
            field
            messages
        }
    }
} `



class OverviewTab extends Component {
    constructor(props) {
        super(props)
        this.state = {
            error: null,
            loading: false,
            openModal: "",
            editField: "",
            fieldLoading: {},
            inputValues: {},
            originalValues: {},
            fieldErrors: {},
            incidentDamageTab: "#incidentDamages",
            selectedDamages: [],
        }
    }

    editField = (fieldName, fieldValue = "") => {
        if (this.state.editField && this.state.editField !== fieldName) {
            this.setState(prev => ({
                fieldErrors: { ...prev.fieldErrors, [fieldName]: "Please save or cancel the current edit before editing this field." }
            }))
            return
        }
        this.setState(prevState => ({
            editField: fieldName,
            inputValues: {
                ...prevState.inputValues,
                [fieldName]: fieldValue
            },
            originalValues: {
                ...prevState.originalValues,
                [fieldName]: fieldValue
            },
            error: null
        }))
    }

    saveField = (fieldName, fieldValue) => {
        if (fieldValue === undefined || fieldValue === null || fieldValue === "") {
            this.cancelEdit()
            return
        }
        if (this.state.fieldErrors[fieldName]) return
        this.updateIncidents(this.props.id, fieldName, fieldValue)
    }

    updateIncidents = async (incidentId, name, value) => {
        const trimmedValue = typeof value === 'string' ? value.trim() : value

        if (trimmedValue === this.state.originalValues[name]) {
            this.cancelEdit()
            return
        }

        const isValidValue = typeof trimmedValue === "boolean" || Boolean(trimmedValue)
        if (!incidentId || !name || !isValidValue) return

        this.setState({
            fieldLoading: { ...this.state.fieldLoading, [name]: true },
            error: "",
            fieldErrors: { ...this.state.fieldErrors, [name]: "" },
        })

        const input = {
            incidentId: incidentId,
            [name]: trimmedValue,
        }

        try {
            const result = await this.props.apolloClient.mutate({
                mutation: UpdateIncident,
                variables: { input },
            })

            const { ok, errors } = result?.data?.updateIncident || {}

            if (ok) {
                this.setState((prev) => ({
                    editField: "",
                    error: "",
                    inputValues: { ...prev.inputValues, [name]: trimmedValue },
                    originalValues: { ...prev.originalValues, [name]: trimmedValue },
                    fieldErrors: { ...prev.fieldErrors, [name]: "" },
                }))
                this.props.refetchQuery()
            } else {
                const errorMessage = errors?.[0]?.messages?.toString() || "Something went wrong, Please contact admin for support!"
                this.setState((prev) => ({
                    error: errorMessage,
                    fieldErrors: { ...prev.fieldErrors, [name]: errorMessage },
                    editField: name,
                }))
            }
        } catch (err) {
            this.setState((prev) => ({
                error: err.message,
                fieldErrors: { ...prev.fieldErrors, [name]: err.message },
                editField: name,
            }))
        } finally {
            this.setState((prev) => ({
                fieldLoading: { ...prev.fieldLoading, [name]: false },
            }))
        }
    };

    cancelEdit = () => {
        if (!this.state.editField) return
        this.setState({
            editField: "",
            inputValues: {},
            originalValues: {},
            fieldErrors: {},
            error: "",
            fieldLoading: {},
        })
    }

    updateInput = (e) => {
        this.setState({ error: "", fieldErrors: { ...this.state.fieldErrors, [e.target.name]: "" } })
        const rawValue = e.target.value
        const fieldName = e.target.name
        const fieldType = e.target.type

        this.setState(prevState => ({
            inputValues: {
                ...prevState.inputValues,
                [fieldName]: fieldType === "select-one" ? rawValue === "true" ? true : rawValue === "false" ? false : rawValue : rawValue
            }
        }))
    }

    pObj = (jsonString) => {
        let obj = JSON.parse(jsonString)
        return obj
    }

    viewPictures = (carPictures, index = 0) => {
        let pictures = carPictures?.map(picture => ({ documentUrl: cleanDocumentUrl(picture.node.pictureUrl), id: picture.node.id, name: toTitleCase(picture.node.pictureType), description: picture.node.description, dateAdded: picture.node.dateAdded }))
        this.setState({ carPictures: pictures, selectedImage: pictures[index] })
    }
    next = () => {
        const carPictures = this.state.carPictures
        const currentIndex = carPictures.findIndex(item => item.id === this.state.selectedImage.id)
        if (currentIndex === carPictures.length - 1) return
        this.setState({ selectedImage: carPictures[currentIndex + 1] })
    }
    prev = () => {
        const carPictures = this.state.carPictures
        const currentIndex = carPictures.findIndex(item => item.id === this.state.selectedImage.id)
        if (currentIndex === 0) return
        this.setState({ selectedImage: carPictures[currentIndex - 1] })
    }

    toggleModal = (modalName) => {
        if (this.state.openModal === modalName) {
            this.setState({ openModal: "", error: "" })
        } else {
            this.setState({ openModal: modalName, error: "" })
        }
    }

    handleDamageSelection = (damageId) => {
        if (this.state.selectedDamages?.includes(damageId)) {
            this.setState(prevState => ({
                selectedDamages: prevState.selectedDamages.filter(id => id !== damageId)
            }))
        } else {
            this.setState(prevState => ({
                selectedDamages: [...prevState.selectedDamages, damageId]
            }))
        }
    }

    handleClose = () => {
        this.setState({
            loading: false,
            error: "",
            openModal: "",
            selectedDamages: [],
        })
    }

    render() {
        const fieldDescriptions = this.props.incidentNodeFieldDescriptions?.fields.reduce((acc, field) => {
            acc[field.name] = field.description
            return acc
        }, {})

        // Map enum values to options with label and value
        const mapEnumToOptions = (enumValues) => {
            return enumValues?.map(({ name, description }) => ({
                value: name,
                label: description || name
            }))
        }

        const ridesharePlatformOptions = mapEnumToOptions(this.props.ridesharePlatformChoices?.enumValues)
        const ridesharePeriodOptions = mapEnumToOptions(this.props.ridesharePeriodChoices?.enumValues)
        const ridesharePeriodSourceOptions = mapEnumToOptions(this.props.ridesharePeriodSourceChoices?.enumValues)
        const responsiblePartyOptions = mapEnumToOptions(this.props.responsiblePartyChoices?.enumValues)
        const sourceOptions = mapEnumToOptions(this.props.sourceChoices?.enumValues)
        const statusOptions = mapEnumToOptions(this.props.statusChoices?.enumValues)
        const reportedByOptions = mapEnumToOptions(this.props.reportedByChoices?.enumValues)
        const incidentTypeOptions = mapEnumToOptions(this.props.incidentTypeChoices?.enumValues)
        const carTotaledOptions = mapEnumToOptions(this.props.carTotaledChoices?.enumValues)
        const booleanOptions = [{ value: true, label: "Yes" }, { value: false, label: "No" }]
        const states = getStatesByCountry("us")
        const stateOptions = getStateOptions(states)
        const branchOptions = this.props.branchOptions?.edges?.map(({ node }) => ({
            value: node.id,
            label: node.name,
        })) || []

        const metadata = this.props.incident?.metadata ? JSON.parse(this.props.incident.metadata) : {}
        const externalSystems = metadata.external_ids || {}
        const mondayItemId = metadata.monday_row_id || null
        const mondayRowTitle = metadata.monday_row_title || null

        return (
            <div className="overview-tab-container">
                {this.state.selectedImage &&
                    <DocumentModalNew
                        document={this.state.selectedImage}
                        handleClose={() => this.setState({ selectedImage: null })}
                        next={this.next}
                        prev={this.prev}
                        objectType={"car"}
                        isPicture={true}
                        refetch={this.props.refetch}
                        currentUser={this.props.currentUser}
                    />
                }
                <Row>
                    <Col xs="12" className="pb-2">
                        <h4>INCIDENT OVERVIEW</h4>
                        <div className='info-container'>
                            {!this.state.editField && this.state.error && <Row>
                                <Col>
                                    <Alert color="danger" className="mt-2 mb-0">{this.state.error}</Alert>
                                </Col>
                            </Row>}
                            <Row>
                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={3}><Skeleton count={1} height={30} /></Col> : <Col xs={3}>
                                    <Label>Created At</Label>
                                    <div className="input-alternative-box" style={{ border: "1px solid #d7dce2", borderRadius: "7px" }}>

                                        <DatetimeRenderer datetime={this.props.incident?.dateAdded} />
                                    </div>
                                </Col>}
                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={3}><Skeleton count={1} height={30} /></Col> :
                                    <>
                                        <CustomInputField
                                            label="Incident Date"
                                            fieldName="incidentDate"
                                            fieldDescription={fieldDescriptions?.incidentDate}
                                            showCopyIcon={false}
                                            showEditIcon={!this.props.incident?.isArchived}
                                            inputType="date"
                                            error={this.state.fieldErrors?.incidentDate || null}
                                            isEditing={this.state.editField === "incidentDate"}
                                            isLoading={!!this.state.fieldLoading.incidentDate}
                                            inputValue={(this.state.inputValues.incidentDate || this.props.incident?.incidentDate) ? moment(this.state.inputValues.incidentDate || this.props.incident?.incidentDate).format("YYYY-MM-DD") : null}
                                            currentValue={this.props.incident?.incidentDate ? moment(this.props.incident?.incidentDate).format("YYYY-MM-DD") : null}
                                            maxValue={moment().format("YYYY-MM-DD")}
                                            onEdit={this.editField}
                                            onSave={this.saveField}
                                            onChange={this.updateInput}
                                            onCancel={this.cancelEdit}
                                        />
                                    </>
                                }

                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={3}><Skeleton count={1} height={30} /></Col> :
                                    <CustomInputField
                                        label="Incident Time"
                                        fieldName="incidentTime"
                                        fieldDescription={fieldDescriptions?.incidentTime}
                                        showCopyIcon={false}
                                        inputType="time"
                                        error={this.state.fieldErrors?.incidentTime || null}
                                        isEditing={this.state.editField === "incidentTime"}
                                        isLoading={!!this.state.fieldLoading.incidentTime}
                                        inputValue={(this.state.inputValues.incidentTime || this.props.incident?.incidentTime) ? moment(this.state.inputValues.incidentTime || this.props.incident?.incidentTime, "HH:mm:ss").format("HH:mm") : null}
                                        currentValue={this.props.incident?.incidentTime ? moment(this.props.incident?.incidentTime, "HH:mm:ss").format("hh:mm A") : null}
                                        showEditIcon={!this.props.incident?.isArchived}
                                        onEdit={this.editField}
                                        onSave={this.saveField}
                                        onChange={this.updateInput}
                                        onCancel={this.cancelEdit}
                                    />}
                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={3}><Skeleton count={1} height={30} /></Col> :
                                    <PreferredDateTimeContext.Consumer>
                                        {({ preferredDateTimeInfo }) => {
                                            let displayValue = "";
                                            let inputType = "datetime-local";
                                            if (this.props.incident?.notificationDate) {
                                                const [date, time] = this.props.incident?.notificationDate.split("T");
                                                if (time?.startsWith("00:00")) {
                                                    displayValue = date;
                                                    inputType = "date";
                                                } else {
                                                    displayValue = moment(this.props.incident?.notificationDate).tz(preferredDateTimeInfo.timezone).format(moment.HTML5_FMT.DATETIME_LOCAL);
                                                }
                                            }

                                            return (
                                                <CustomInputField
                                                    label="Notification Datetime"
                                                    fieldName="notificationDatetime"
                                                    id="notificationDatetime"
                                                    fieldDescription={fieldDescriptions?.notificationDate}
                                                    showCopyIcon={false}
                                                    error={this.state.fieldErrors?.notificationDatetime || null}
                                                    inputType={inputType}
                                                    currentValue={displayValue}
                                                    inputValue={displayValue}
                                                    showEditIcon={!this.props.incident?.isArchived}
                                                    onEdit={() => this.toggleModal("notificationDatetime")}
                                                    renderEditingModal={() =>
                                                        this.state.openModal === "notificationDatetime" &&
                                                        <UpdateIncidentInfo
                                                            title="Edit Incident Notification Datetime"
                                                            name="notificationDatetime"
                                                            type="datetime-local"
                                                            value={moment(this.props.incident?.notificationDate || new Date()).tz(preferredDateTimeInfo.timezone).format(moment.HTML5_FMT.DATETIME_LOCAL)}
                                                            min={moment(this.props.incident?.incidentDate).tz(preferredDateTimeInfo.timezone).format(moment.HTML5_FMT.DATETIME_LOCAL)}
                                                            max={moment().tz(preferredDateTimeInfo.timezone).format(moment.HTML5_FMT.DATETIME_LOCAL)}
                                                            open={this.state.openModal === "notificationDatetime"}
                                                            target="notificationDatetime"
                                                            handleClose={() => this.toggleModal("")}
                                                            incidentId={this.props.incident?.id}
                                                            refetchIncident={this.props.refetchQuery}
                                                        />
                                                    }
                                                />
                                            );
                                        }}
                                    </PreferredDateTimeContext.Consumer>
                                }
                            </Row>
                            <Row className='mt-2'>
                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={3}><Skeleton count={1} height={30} /></Col> :
                                    <CustomInputField
                                        label="Status"
                                        fieldName="status"
                                        fieldDescription={fieldDescriptions?.status}
                                        showCopyIcon={false}
                                        inputType="select"
                                        error={this.state.fieldErrors?.status || null}
                                        options={statusOptions}
                                        isEditing={this.state.editField === "status"}
                                        isLoading={!!this.state.fieldLoading.status}
                                        inputValue={this.state.inputValues.status || this.props.incident?.status}
                                        currentValue={this.props.incident?.status}
                                        showEditIcon={!this.props.incident?.isRecordOnly && !this.props.incident?.isArchived}
                                        onEdit={this.editField}
                                        onSave={this.saveField}
                                        onChange={this.updateInput}
                                        onCancel={this.cancelEdit}
                                        customCssClass={"border border-warning"}
                                    />
                                }
                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={3}><Skeleton count={1} height={30} /></Col> :
                                    <CustomInputField
                                        label="Reported By"
                                        fieldName="reportedBy"
                                        fieldDescription={fieldDescriptions?.reportedBy}
                                        showCopyIcon={false}
                                        inputType="select"
                                        error={this.state.fieldErrors?.reportedBy || null}
                                        options={reportedByOptions}
                                        isEditing={this.state.editField === "reportedBy"}
                                        isLoading={!!this.state.fieldLoading.reportedBy}
                                        inputValue={this.state.inputValues.reportedBy || this.props.incident?.reportedBy}
                                        currentValue={this.props.incident?.reportedBy}
                                        showEditIcon={!this.props.incident?.isArchived}
                                        onEdit={this.editField}
                                        onSave={this.saveField}
                                        onChange={this.updateInput}
                                        onCancel={this.cancelEdit}
                                    />
                                }
                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={3}><Skeleton count={1} height={30} /></Col> :
                                    <CustomInputField
                                        label="Source"
                                        fieldName="source"
                                        fieldDescription={fieldDescriptions?.source}
                                        showCopyIcon={false}
                                        inputType="select"
                                        error={this.state.fieldErrors?.source || null}
                                        options={sourceOptions}
                                        isEditing={this.state.editField === "source"}
                                        isLoading={!!this.state.fieldLoading.source}
                                        inputValue={this.state.inputValues.source || this.props.incident?.source}
                                        currentValue={this.props.incident?.source}
                                        showEditIcon={!this.props.incident?.isArchived}
                                        onEdit={this.editField}
                                        onSave={this.saveField}
                                        onChange={this.updateInput}
                                        onCancel={this.cancelEdit}
                                    />
                                }
                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={3}><Skeleton count={1} height={30} /></Col> :
                                    <CustomInputField
                                        label="Incident Type"
                                        fieldName="incidentType"
                                        fieldDescription={fieldDescriptions?.incidentType}
                                        showCopyIcon={false}
                                        inputType="select"
                                        error={this.state.fieldErrors?.incidentType || null}
                                        options={incidentTypeOptions}
                                        isEditing={this.state.editField === "incidentType"}
                                        isLoading={!!this.state.fieldLoading.incidentType}
                                        inputValue={this.state.inputValues.incidentType || this.props.incident?.incidentType}
                                        currentValue={this.props.incident?.incidentType || null}
                                        showEditIcon={!this.props.incident?.isArchived}
                                        onEdit={this.editField}
                                        onSave={this.saveField}
                                        onChange={this.updateInput}
                                        onCancel={this.cancelEdit}
                                    />
                                }
                            </Row>
                            <Row className='mt-2'>
                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={3}><Skeleton count={1} height={30} /></Col> :
                                    <CustomInputField
                                        label="DMV Plate"
                                        fieldName="dmvPlate"
                                        fieldDescription={fieldDescriptions?.dmvPlate}
                                        showCopyIcon={false}
                                        inputType="text"
                                        inputValue={this.state.inputValues.dmvPlate || this.props.incident?.dmvPlate}
                                        currentValue={this.props.incident?.dmvPlate}
                                        showEditIcon={false}

                                    />
                                }
                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={3}><Skeleton count={1} height={30} /></Col> :
                                    <CustomInputField
                                        label="Is Record Only?"
                                        fieldName="isRecordOnly"
                                        fieldDescription={fieldDescriptions?.isRecordOnly}
                                        showCopyIcon={false}
                                        inputType="select"
                                        error={this.state.fieldErrors?.isRecordOnly || null}
                                        options={booleanOptions}
                                        isEditing={this.state.editField === "isRecordOnly"}
                                        isLoading={!!this.state.fieldLoading.isRecordOnly}
                                        inputValue={this.state.inputValues.isRecordOnly !== undefined ? this.state.inputValues.isRecordOnly : this.props.incident?.isRecordOnly}
                                        currentValue={this.props.incident?.isRecordOnly !== undefined ? this.props.incident?.isRecordOnly : "--"}
                                        showEditIcon={!this.props.incident?.isArchived}
                                        onEdit={this.editField}
                                        onSave={this.saveField}
                                        onChange={this.updateInput}
                                        onCancel={this.cancelEdit}
                                    />
                                }
                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={3}><Skeleton count={1} height={30} /></Col> :
                                    <CustomInputField
                                        label="Location"
                                        fieldName="location"
                                        fieldDescription={fieldDescriptions?.location}
                                        showCopyIcon={false}
                                        inputType="text"
                                        error={this.state.fieldErrors?.location || null}
                                        isEditing={this.state.editField === "location"}
                                        isLoading={!!this.state.fieldLoading.location}
                                        inputValue={this.state.inputValues.location || this.props.incident?.location}
                                        currentValue={this.props.incident?.location}
                                        showEditIcon={!this.props.incident?.isArchived}
                                        onEdit={this.editField}
                                        onSave={this.saveField}
                                        onChange={this.updateInput}
                                        onCancel={this.cancelEdit}
                                        renderEditingModal={() =>
                                            this.state.editField === "location" &&
                                            <Popover trigger="legacy" placement="left" isOpen={true} target="location" toggle={this.cancelEdit} style={{ minWidth: "350px" }}>
                                                <PopoverBody>
                                                    <MapPicker
                                                        initialLocation={this.props.incident?.location || ""}
                                                        onLocationSelect={(loc) => {
                                                            this.setState(prevState => ({
                                                                inputValues: {
                                                                    ...prevState.inputValues,
                                                                    location: loc.address || "",
                                                                    incidentState: loc.state || prevState.inputValues.incidentState
                                                                }
                                                            }))
                                                        }}
                                                    />
                                                    <div className="d-flex justify-content-end">
                                                        <Button
                                                            color="primary"
                                                            className="mt-2 mb-2"
                                                            onClick={() => {
                                                                this.saveField("location", this.state.inputValues.location)
                                                                setTimeout(() => {
                                                                    this.saveField("incidentState", this.state.inputValues.incidentState)
                                                                }, 100)
                                                            }}
                                                            disabled={!!this.state.fieldLoading.location || !!this.state.fieldLoading.incidentState}
                                                        >
                                                            {(!!this.state.fieldLoading.location || !!this.state.fieldLoading.incidentState) ? "Saving..." : "Save"}
                                                        </Button>
                                                    </div>
                                                </PopoverBody>
                                            </Popover>
                                        }
                                    />
                                }
                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={3}><Skeleton count={1} height={30} /></Col> :
                                    <CustomInputField
                                        label="Incident State"
                                        fieldName="incidentState"
                                        fieldDescription={fieldDescriptions?.incidentState}
                                        showCopyIcon={false}
                                        inputType="select"
                                        error={this.state.fieldErrors?.incidentState || null}
                                        options={stateOptions}
                                        isEditing={this.state.editField === "incidentState"}
                                        isLoading={!!this.state.fieldLoading.incidentState}
                                        inputValue={this.state.inputValues.incidentState || this.props.incident?.incidentState}
                                        currentValue={this.props.incident?.incidentState}
                                        showEditIcon={!this.props.incident?.isArchived}
                                        onEdit={this.editField}
                                        onSave={this.saveField}
                                        onChange={this.updateInput}
                                        onCancel={this.cancelEdit}
                                    />
                                }
                            </Row>
                            <Row className='mt-2'>
                                {(this.props.incidentLoading && !this.props.incident) ? <Col><Skeleton count={1} height={30} /></Col> :
                                    <CustomInputField
                                        label="Rideshare Period"
                                        fieldName="ridesharePeriod"
                                        fieldDescription={fieldDescriptions?.ridesharePeriod}
                                        showCopyIcon={false}
                                        inputType="select"
                                        error={this.state.fieldErrors?.ridesharePeriod || null}
                                        options={ridesharePeriodOptions}
                                        isEditing={this.state.editField === "ridesharePeriod"}
                                        isLoading={!!this.state.fieldLoading.ridesharePeriod}
                                        inputValue={this.state.inputValues.ridesharePeriod || this.props.incident?.ridesharePeriod}
                                        currentValue={this.props.incident?.ridesharePeriod}
                                        showEditIcon={!this.props.incident?.isArchived}
                                        onEdit={this.editField}
                                        onSave={this.saveField}
                                        onChange={this.updateInput}
                                        onCancel={this.cancelEdit}
                                    />
                                }
                                {this.props.incident?.ridesharePeriod && !["X", "ZERO"].includes(this.props.incident?.ridesharePeriod) && <>
                                    {(this.props.incidentLoading && !this.props.incident) ? <Col><Skeleton count={1} height={30} /></Col> :
                                        <CustomInputField
                                            label="Rideshare Platform"
                                            fieldName="ridesharePlatform"
                                            fieldDescription={fieldDescriptions?.ridesharePlatform}
                                            showCopyIcon={false}
                                            inputType="select"
                                            error={this.state.fieldErrors?.ridesharePlatform || null}
                                            options={ridesharePlatformOptions}
                                            isEditing={this.state.editField === "ridesharePlatform"}
                                            isLoading={!!this.state.fieldLoading.ridesharePlatform}
                                            inputValue={this.state.inputValues.ridesharePlatform || this.props.incident?.ridesharePlatform}
                                            currentValue={this.props.incident?.ridesharePlatform}
                                            showEditIcon={!this.props.incident?.isArchived}
                                            onEdit={this.editField}
                                            onSave={this.saveField}
                                            onChange={this.updateInput}
                                            onCancel={this.cancelEdit}
                                        />
                                    }
                                    {(this.props.incidentLoading && !this.props.incident) ? <Col><Skeleton count={1} height={30} /></Col> :
                                        <CustomInputField
                                            label="Rideshare Period Source"
                                            fieldName="ridesharePeriodSource"
                                            fieldDescription={fieldDescriptions?.ridesharePeriodSource}
                                            showCopyIcon={false}
                                            inputType="select"
                                            error={this.state.fieldErrors?.ridesharePeriodSource || null}
                                            options={ridesharePeriodSourceOptions}
                                            isEditing={this.state.editField === "ridesharePeriodSource"}
                                            isLoading={!!this.state.fieldLoading.ridesharePeriodSource}
                                            inputValue={this.state.inputValues.ridesharePeriodSource || this.props.incident?.ridesharePeriodSource}
                                            currentValue={this.props.incident?.ridesharePeriodSource}
                                            showEditIcon={!this.props.incident?.isArchived}
                                            onEdit={this.editField}
                                            onSave={this.saveField}
                                            onChange={this.updateInput}
                                            onCancel={this.cancelEdit}
                                        />
                                    }
                                    {this.props.incident?.ridesharePlatform && this.props.incident.ridesharePeriodSource && <>
                                        {(this.props.incidentLoading && !this.props.incident) ? <Col><Skeleton count={1} height={30} /></Col> :
                                            <CustomInputField
                                                label="Rideshare Incident ID"
                                                fieldName="rideshareIncidentId"
                                                fieldDescription={fieldDescriptions?.rideshareIncidentId}
                                                showCopyIcon={false}
                                                inputType="text"
                                                error={this.state.fieldErrors?.rideshareIncidentId || null}
                                                isEditing={this.state.editField === "rideshareIncidentId"}
                                                isLoading={!!this.state.fieldLoading.rideshareIncidentId}
                                                inputValue={this.state.inputValues.rideshareIncidentId || this.props.incident?.rideshareIncidentId}
                                                currentValue={this.props.incident?.rideshareIncidentId}
                                                showEditIcon={!this.props.incident?.isArchived}
                                                onEdit={this.editField}
                                                onSave={this.saveField}
                                                onChange={this.updateInput}
                                                onCancel={this.cancelEdit}
                                            />
                                        }
                                    </>
                                    }
                                </>}
                            </Row>

                            <Row className='mt-2'>
                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={3}><Skeleton count={1} height={30} /></Col> :
                                    <CustomInputField
                                        colSize={3}
                                        label="Responsible Party"
                                        fieldName="responsibleParty"
                                        fieldDescription={fieldDescriptions?.responsibleParty}
                                        showCopyIcon={false}
                                        inputType="select"
                                        error={this.state.fieldErrors?.responsibleParty || null}
                                        options={responsiblePartyOptions}
                                        isEditing={this.state.editField === "responsibleParty"}
                                        isLoading={!!this.state.fieldLoading.responsibleParty}
                                        inputValue={this.state.inputValues.responsibleParty || this.props.incident?.responsibleParty}
                                        currentValue={this.props.incident?.responsibleParty}
                                        showEditIcon={!this.props.incident?.isArchived}
                                        onEdit={this.editField}
                                        onSave={this.saveField}
                                        onChange={this.updateInput}
                                        onCancel={this.cancelEdit}
                                    />
                                }
                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={3}><Skeleton count={1} height={30} /></Col> :
                                    <CustomInputField
                                        label="Has Dashcam Videos?"
                                        fieldName="hasDashcamVideos"
                                        fieldDescription={fieldDescriptions?.hasDashcamVideos}
                                        showCopyIcon={false}
                                        inputType='select'
                                        error={this.state.fieldErrors?.hasDashcamVideos || null}
                                        options={carTotaledOptions}
                                        isEditing={this.state.editField === "hasDashcamVideos"}
                                        isLoading={!!this.state.fieldLoading.hasDashcamVideos}
                                        inputValue={this.state.inputValues.hasDashcamVideos !== undefined ? this.state.inputValues.hasDashcamVideos : this.props.incident?.hasDashcamVideos}
                                        currentValue={this.props.incident?.hasDashcamVideos}
                                        showEditIcon={!this.props.incident?.isArchived}
                                        onEdit={this.editField}
                                        onSave={this.saveField}
                                        onChange={this.updateInput}
                                        onCancel={this.cancelEdit}
                                    />
                                }

                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={3}><Skeleton count={1} height={30} /></Col> :
                                    <CustomInputField
                                        label="Has Police Report?"
                                        fieldName="hasPoliceReport"
                                        fieldDescription={fieldDescriptions?.hasPoliceReport}
                                        showCopyIcon={false}
                                        showEditIcon={!this.props.incident?.isArchived}
                                        inputType="select"
                                        error={this.state.fieldErrors?.hasPoliceReport || null}
                                        options={carTotaledOptions}
                                        isEditing={this.state.editField === "hasPoliceReport"}
                                        inputValue={this.state.inputValues.hasPoliceReport !== undefined ? this.state.inputValues.hasPoliceReport : this.props.incident?.hasPoliceReport}
                                        currentValue={this.props.incident?.hasPoliceReport}
                                        isLoading={!!this.state.fieldLoading.hasPoliceReport}
                                        onEdit={this.editField}
                                        onSave={this.saveField}
                                        onChange={this.updateInput}
                                        onCancel={this.cancelEdit}
                                    />
                                }
                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={3}><Skeleton count={1} height={30} /></Col> :
                                    <CustomInputField
                                        showEditIcon={!this.props.incident?.isArchived}
                                        label="Has Other Parties?"
                                        fieldName="hasOtherParties"
                                        fieldDescription={fieldDescriptions?.hasOtherParties}
                                        showCopyIcon={false}
                                        inputType="select"
                                        error={this.state.fieldErrors?.hasOtherParties || null}
                                        options={carTotaledOptions}
                                        isEditing={this.state.editField === "hasOtherParties"}
                                        isLoading={!!this.state.fieldLoading.hasOtherParties}
                                        inputValue={this.state.inputValues.hasOtherParties !== undefined ? this.state.inputValues.hasOtherParties : this.props.incident?.hasOtherParties}
                                        currentValue={this.props.incident?.hasOtherParties}
                                        onEdit={this.editField}
                                        onSave={this.saveField}
                                        onChange={this.updateInput}
                                        onCancel={this.cancelEdit}
                                    />
                                }
                            </Row>
                            <Row className='mt-2'>
                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={3}><Skeleton count={1} height={30} /></Col> :
                                    <CustomInputField
                                        label="Has Liability Claim?"
                                        fieldName="hasLiabilityClaim"
                                        fieldDescription={fieldDescriptions?.hasLiabilityClaim}
                                        showCopyIcon={false}
                                        inputType="select"
                                        error={this.state.fieldErrors?.hasLiabilityClaim || null}
                                        options={carTotaledOptions}
                                        isEditing={this.state.editField === "hasLiabilityClaim"}
                                        isLoading={!!this.state.fieldLoading.hasLiabilityClaim}
                                        inputValue={this.state.inputValues.hasLiabilityClaim || this.props.incident?.hasLiabilityClaim}
                                        currentValue={this.props.incident?.hasLiabilityClaim}
                                        showEditIcon={!this.props.incident?.isArchived && this.props.incident?.incidentDate}
                                        onEdit={this.editField}
                                        onSave={this.saveField}
                                        onChange={this.updateInput}
                                        onCancel={this.cancelEdit}
                                    />
                                }
                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={3}><Skeleton count={1} height={30} /></Col> :
                                    <CustomInputField
                                        label="Has Subro Claim?"
                                        fieldName="hasSubroClaim"
                                        fieldDescription={fieldDescriptions?.hasSubroClaim}
                                        showCopyIcon={false}
                                        inputType="select"
                                        error={this.state.fieldErrors?.hasSubroClaim || null}
                                        options={carTotaledOptions}
                                        isEditing={this.state.editField === "hasSubroClaim"}
                                        isLoading={!!this.state.fieldLoading.hasSubroClaim}
                                        inputValue={this.state.inputValues.hasSubroClaim || this.props.incident?.hasSubroClaim}
                                        currentValue={this.props.incident?.hasSubroClaim}
                                        showEditIcon={!this.props.incident?.isArchived}
                                        onEdit={this.editField}
                                        onSave={this.saveField}
                                        onChange={this.updateInput}
                                        onCancel={this.cancelEdit}
                                    />
                                }
                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={3}><Skeleton count={1} height={30} /></Col> :
                                    <CustomInputField
                                        label="Car Totaled"
                                        fieldName="carTotaled"
                                        fieldDescription={fieldDescriptions?.carTotaled}
                                        showCopyIcon={false}
                                        inputType="select"
                                        error={this.state.fieldErrors?.carTotaled || null}
                                        options={carTotaledOptions}
                                        isEditing={this.state.editField === "carTotaled"}
                                        isLoading={!!this.state.fieldLoading.carTotaled}
                                        inputValue={this.state.inputValues.carTotaled !== undefined ? this.state.inputValues.carTotaled : this.props.incident?.carTotaled}
                                        currentValue={this.props.incident?.carTotaled !== undefined ? this.props.incident?.carTotaled : null}
                                        showEditIcon={!this.props.incident?.isArchived}
                                        onEdit={this.editField}
                                        onSave={this.saveField}
                                        onChange={this.updateInput}
                                        onCancel={this.cancelEdit}
                                    />
                                }
                                <Col>
                                    <Row>
                                        <Col xs="9">
                                            <Label>Assigned To</Label>
                                        </Col>
                                        <Col xs="3" className="text-right">
                                            {!this.props.incident?.isArchived && <i id={`assignedToEdit${this.props.incident?.pk}`} className="fa fa-lg fa-pencil-square cursor-pointer" onClick={() => this.editField("assignedTo")} title="Edit" />}

                                            {this.state.editField === "assignedTo" &&
                                                <UpdateIncidentInfo
                                                    title="Edit Assigned To"
                                                    name="assignedToIds"
                                                    type="select"
                                                    open={this.state.editField === "assignedTo"}
                                                    value={this.props.incident?.assignedTo?.edges?.map(e => e.node) || []}
                                                    target={`assignedToEdit${this.props.incident?.pk}`}
                                                    handleClose={this.cancelEdit}
                                                    incidentId={this.props.incident?.id}
                                                    refetchIncident={this.props.refetchQuery}
                                                />
                                            }
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12}>
                                            {this.props.incident?.assignedTo?.edges?.length > 0 ? this.props.incident?.assignedTo?.edges.map(e => <RepAvatar key={e.node.id} rep={e.node} />) : <RepAvatar />}
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className='mt-2'>
                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={3}><Skeleton count={1} height={30} /></Col> :
                                    <CustomInputField
                                        label="Incident Branch"
                                        fieldName="branchId"
                                        fieldDescription={fieldDescriptions?.branch}
                                        showCopyIcon={false}
                                        inputType="select"
                                        error={this.state.fieldErrors?.branchId || null}
                                        options={branchOptions}
                                        isEditing={this.state.editField === "branchId"}
                                        isLoading={!!this.state.fieldLoading.branchId}
                                        inputValue={this.state.inputValues.branchId || this.props.incident?.branch?.id}
                                        currentValue={this.props.incident?.branch?.id || ""}
                                        showEditIcon={this.props.incident?.canChangeBranch && this.props.hasPermissions?.includes("custom_can_change_incident_branch") && !this.props.incident?.isArchived}
                                        onEdit={this.editField}
                                        onSave={this.saveField}
                                        onChange={this.updateInput}
                                        onCancel={this.cancelEdit}
                                    />
                                }
                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={3}><Skeleton count={1} height={30} /></Col> :
                                    <CustomInputField
                                        label="Car On Hold"
                                        fieldName="carOnHold"
                                        fieldDescription={fieldDescriptions?.carOnHold}
                                        showCopyIcon={false}
                                        inputType="select"
                                        error={this.state.fieldErrors?.carOnHold || null}
                                        options={booleanOptions}
                                        isEditing={this.state.editField === "carOnHold"}
                                        isLoading={!!this.state.fieldLoading.carOnHold}
                                        inputValue={this.state.inputValues.carOnHold !== undefined ? this.state.inputValues.carOnHold : this.props.incident?.carOnHold}
                                        currentValue={this.props.incident?.carOnHold !== undefined ? this.props.incident?.carOnHold : null}
                                        showEditIcon={this.props.hasPermissions?.includes("custom_can_edit_car_on_hold") && !this.props.incident?.isArchived}
                                        onEdit={this.editField}
                                        onSave={this.saveField}
                                        onChange={this.updateInput}
                                        onCancel={this.cancelEdit}
                                    />
                                }
                            </Row>
                            <Row className='mt-2'>
                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={6}><Skeleton count={1} height={30} /></Col> :
                                    <CustomInputField
                                        showEditIcon={!this.props.incident?.isArchived}
                                        label="Description"
                                        fieldName="description"
                                        fieldDescription={fieldDescriptions?.description}
                                        showCopyIcon={false}
                                        inputType="textarea"
                                        error={this.state.fieldErrors?.description || null}
                                        isEditing={this.state.editField === "description"}
                                        isLoading={!!this.state.fieldLoading.description}
                                        inputValue={this.state.inputValues.description || this.props.incident?.description ? this.state.inputValues.description || this.props.incident?.description : null}
                                        currentValue={this.props.incident?.description}
                                        onEdit={this.editField}
                                        onSave={this.saveField}
                                        onChange={this.updateInput}
                                        onCancel={this.cancelEdit}
                                    />
                                }
                                {(this.props.incidentLoading && !this.props.incident) ? <Col xs={6}><Skeleton count={1} height={30} /></Col> :
                                    <>
                                        <CustomInputField
                                            showEditIcon={!this.props.incident?.isArchived}
                                            showHistoryIcon={true}
                                            label="Notes"
                                            fieldName="notes"
                                            fieldDescription={fieldDescriptions?.notes}
                                            showCopyIcon={false}
                                            inputType="textarea"
                                            error={this.state.fieldErrors?.notes || null}
                                            isEditing={this.state.editField === "notes"}
                                            isLoading={!!this.state.fieldLoading.notes}
                                            inputValue={this.state.inputValues.notes || this.props.incident?.notes}
                                            currentValue={this.props.incident?.notes}
                                            onEdit={this.editField}
                                            onSave={this.saveField}
                                            onChange={this.updateInput}
                                            onCancel={this.cancelEdit}
                                            renderAdditionalActions={() =>
                                                <>
                                                    <FieldHistoryPopover title={"Notes"} history={this.props.incident?.history?.filter(item => item.comment.toLowerCase().includes("notes:")) || []} isOpen={this.state.showNotesHistoryModal} target="notes-history" toggle={() => this.setState({ showNotesHistoryModal: false })} />
                                                    <span id={`notes-history`}>
                                                        <i className="fa fa-lg fa-history cursor-pointer" onClick={() => this.setState({ showNotesHistoryModal: true })} title="View History" />
                                                    </span>
                                                    &nbsp;&nbsp;
                                                </>
                                            }
                                        />
                                    </>
                                }
                            </Row>
                        </div>
                    </Col >
                </Row >
                <Row className='mt-4'>
                    <Col xs={6} className="pb-2">
                        <h4 className='d-flex justify-content-between align-items-center'>
                            ARGYLE GIGS on {this.props.incident?.incidentDate} {this.props.incident?.incidentTime ? `at ${this.props.incident.incidentTime}` : ""}
                        </h4>
                        <div className='info-container'>
                            {/* {this.props.incident?.rental?.driver?.id && this.props.incident?.incidentDate && */}
                            <RenderArgyleGigs driverId={this.props.incident?.rental?.driver?.id} incidentDate={this.props.incident?.incidentDate} incidentTime={this.props.incident?.incidentTime} showAll />
                            {/* } */}
                        </div>
                    </Col>
                    <Col xs={6} className="pb-2">
                        <h4 className='d-flex justify-content-between align-items-center'>
                            Uber Accidents on {this.props.incident?.incidentDate}
                        </h4>
                        <div className='info-container'>
                            <RenderUberAccidents vin={this.props.incident?.car?.vin} incidentDate={this.props.incident?.incidentDate} />
                        </div>
                    </Col>
                </Row>
                <Row className='mt-4' >
                    <Col xs="6" className="pb-2">
                        <h4>VEHICLE DETAILS</h4>
                        <div className='info-container'>
                            <Row>
                                <Col xs={3}>
                                    <Label>Car</Label>
                                    <p className="columnContent">
                                        {this.props.incident?.car?.pk ? <>
                                            {this.props.incident?.car?.pk} - {this.props.incident?.car && this.props.incident?.car?.carModel ? this.props.incident?.car?.year + " " + toTitleCase(this.props.incident?.car?.carModel.make ? this.props.incident?.car?.carModel.make : "--") + " " + toTitleCase(this.props.incident?.car?.carModel.name ? this.props.incident?.car?.carModel.name : "--") : "--"}
                                            &nbsp;&nbsp;<Link color="primary" to={'/car/' + this.props.incident?.car?.pk} target="_blank"><i className={"fa fa-external-link-square"}></i></Link>
                                        </> : "--"}
                                    </p>
                                </Col>
                                <Col xs={3}>
                                    <Label>Vin</Label>
                                    <p className="columnContent">{this.props.incident?.car?.vin || "--"}</p>
                                </Col>
                                <Col xs={3}>
                                    <Label>Group</Label>
                                    <p className="columnContent">{this.props.incident?.car?.carModel?.groupType?.name || "--"}</p>
                                </Col>
                                <Col xs={3}>
                                    <Label>Color</Label>
                                    <p className="columnContent">{this.props.incident?.car?.color || "--"}</p>
                                </Col>
                                <Col xs={3}>
                                    <Label>DMV Plate</Label>
                                    <p className="columnContent">{this.props.incident?.car?.plate?.dmvPlate || "---"}</p>
                                </Col>
                                {this.props.incident?.car && this.props.incident?.car?.plate && this.props.incident?.car?.plate.fhv &&
                                    <Col xs={3}>
                                        <Label>FHV</Label>
                                        <p className="columnContent">{this.props.incident?.car?.plate?.fhv || "---"}</p>
                                    </Col>
                                }
                                <Col xs={3}>
                                    <Label>Policy</Label>
                                    <p className="columnContent">
                                        {this.props.incident?.car && this.props.incident?.car?.activePolicy && this.props.incident?.car?.activePolicy.insurancePolicy ?
                                            (this.props.incident?.car?.activePolicy.insurancePolicy.broker && this.props.incident?.car?.activePolicy.insurancePolicy.broker.name ? this.props.incident?.car?.activePolicy.insurancePolicy.broker.name : "--") + ": " + this.props.incident?.car?.activePolicy.insurancePolicy.policyNumber :
                                            "None found"
                                        }
                                    </p>
                                </Col>
                                <Col xs={3}>
                                    <Label>Car Branch</Label>
                                    <p className="columnContent">{this.props.incident?.car?.branch?.name || "No Car Branch"}</p>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                    <Col xs="6" className="pb-2">
                        <h4 className='d-flex justify-content-between align-items-center'>
                            <span>
                                DRIVER DETAILS&nbsp;&nbsp;
                                {this.props.incident?.rental?.driver?.currentAgreement?.id &&
                                    <>
                                        <Badge color="success" id="currentAgreementInfo">Active</Badge>
                                        <UncontrolledTooltip placement="top" target="currentAgreementInfo">Driver has an active agreement.</UncontrolledTooltip>
                                    </>
                                }
                            </span>
                            {!this.props.incident?.rental && this.props.incident?.incidentDate && <>
                                <Button className='primary' onClick={() => this.toggleModal("updateIncidentDriver")} style={{ cursor: "pointer" }} id="updateIncidentDriver"><i className="fa fa-plus" /></Button>
                                <UncontrolledTooltip placement="top" target="updateIncidentDriver">Add Driver</UncontrolledTooltip>
                            </>}
                        </h4>
                        <div className='info-container'>
                            <Row>
                                <Col xs={3}>
                                    <Label>Name</Label>
                                    <p className="columnContent">
                                        {this.props.incident?.rental?.driver ?
                                            <>
                                                {this.props.incident?.rental?.driver?.name || "---"} <Link color="primary" to={'/driver/' + this.props.incident?.rental?.driver?.id} target="_blank"><i className={"fa fa-external-link"}></i></Link>
                                            </> :
                                            "---"
                                        }
                                    </p>
                                    {this.state.openModal === "updateIncidentDriver" &&
                                        <UpdateIncidentInfo
                                            title="Edit Incident Driver"
                                            name="rentalId"
                                            type="select"
                                            open={true}
                                            value={this.props.incident?.rental?.id || ""}
                                            carPk={this.props.incident?.car?.pk}
                                            incidentDate={this.props.incident?.incidentDate}
                                            target="updateIncidentDriver"
                                            handleClose={() => this.toggleModal("")}
                                            incidentId={this.props.incident?.id}
                                            refetchIncident={this.props.refetchQuery}
                                        />}
                                </Col>
                                <Col xs={3}>
                                    <Label>Phone Number</Label>
                                    <p className="columnContent">{this.props.incident?.rental?.driver?.phone || "---"}</p>
                                </Col>
                                <Col xs={3}>
                                    <Label>Email</Label>
                                    <p className="columnContent">{this.props.incident?.rental?.driver?.email || "---"}</p>
                                </Col>

                                <Col xs={3}>
                                    <Label>DMV</Label>
                                    <p className="columnContent">{this.props.incident?.rental?.driver?.dmvLicense || "---"}</p>
                                </Col>
                                <Col xs={3}>
                                    <Label>TLC</Label>
                                    <p className="columnContent">{this.props.incident?.rental?.driver?.tlcLicense || "---"}</p>
                                </Col>
                                <Col xs={3} id="paymentMethodEdit">
                                    <Label><span onClick={() => this.toggleModal("paymentMethodEdit")}>Payment Method</span></Label>
                                    <p className="columnContent">{this.props.incident?.rental?.driver?.paymentMethod?.name || "---"}</p>
                                </Col>
                                <Col xs={3} id="chargeDayofweekEdit">
                                    <Label><span onClick={() => this.toggleModal("chargeDayofweekEdit")}>Invoice Day</span></Label>
                                    <p className="columnContent">
                                        {this.props.incident?.rental?.driver && BILLING_DAYS.filter((day, i) => day.value === this.props.incident.rental.driver.chargeDayofweek).map((day, i) => <span key={i}>{day.label}</span>)}
                                    </p>
                                </Col>
                                <Col xs={3}>
                                    <Label>Branch</Label>
                                    <p className="columnContent">{this.props.incident?.rental?.driver?.branch?.name || "---"}</p>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row >
                <Row className='mt-4'>
                    <Col xs={4} className="pb-2">
                        <h4>DAMAGE TRANSACTION</h4>
                        <div className='info-container' style={{ maxHeight: 300, overflowY: 'auto' }}>
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th style={{ fontWeight: 500 }}>ID</th>
                                        <th style={{ fontWeight: 500 }}>Date Added</th>
                                        <th style={{ fontWeight: 500 }}>Charge Type</th>
                                        <th style={{ fontWeight: 500 }}>Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.props.incident?.damageTransaction ?
                                        <>
                                            {this.state.openModal === ("TransactionInfo" + this.props.incident?.damageTransaction.pk) && (
                                                <TransactionInfo
                                                    id={this.props.incident?.damageTransaction.id}
                                                    refetchQuery={this.props.refetchQuery}
                                                    handleClose={() => this.toggleModal("TransactionInfo" + this.props.incident?.damageTransaction.pk)}
                                                    open={this.state.openModal === ("TransactionInfo" + this.props.incident?.damageTransaction.pk)}
                                                    currentUser={this.props.currentUser}
                                                />
                                            )}
                                            <tr>
                                                <td><small>{this.props.incident?.damageTransaction.pk}</small></td>
                                                <td><small>{this.props.incident?.damageTransaction.dateAdded ? <DatetimeRenderer datetime={this.props.incident?.damageTransaction.dateAdded} placement="right" /> : "---"}</small></td>
                                                <td onClick={() => this.toggleModal("TransactionInfo" + this.props.incident?.damageTransaction.pk)} style={{ cursor: "pointer" }}><small>{this.props.incident?.damageTransaction.chargeType ? this.props.incident?.damageTransaction.chargeType.name : "---"}<br /><small>{this.props.incident?.damageTransaction.notes}</small></small></td>
                                                <td><small>${this.props.incident?.damageTransaction?.linkedPaymentPlan?.resultantTransactionsSum || this.props.incident?.damageTransaction.updates?.edges?.find(txn => txn.node.linkedPaymentPlan)?.node?.linkedPaymentPlan?.resultantTransactionsSum || (this.props.incident?.damageTransaction.dynamicAmount ? this.props.incident?.damageTransaction.dynamicAmount : "---")}</small></td>
                                            </tr>
                                        </>
                                        : <tr><td colSpan={4} style={{ color: "red" }}>No Damage Transactions Found!</td></tr>
                                    }
                                </tbody>
                            </Table>
                        </div>
                    </Col>
                    <Col xs={4} className="pb-2">
                        <h4>
                            TASKS&nbsp;
                            {getMissingTaskCount(this.props.incident) > 0 && <>
                                <Badge color="danger" pill id="missingTasksInfo">{getMissingTaskCount(this.props.incident)}</Badge>
                                <UncontrolledTooltip placement="top" target="missingTasksInfo">{getMissingTaskCount(this.props.incident)} tasks are pending</UncontrolledTooltip>
                            </>}
                        </h4>
                        <div className='info-container' style={{ maxHeight: 300, overflowY: 'auto' }}>
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th style={{ fontWeight: 500 }}>Task Name</th>
                                        <th style={{ fontWeight: 500 }}>Task Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {renderTasks(this.props.incident)}
                                </tbody>
                            </Table>
                        </div>
                    </Col>
                    <Col xs={4} className="pb-2">
                        <h4 className='d-flex justify-content-between align-items-center'>
                            LEGACY SYSTEMS
                            <Button color="primary" className="align-middle" id={`addLegacySystemTooltip`} onClick={() => this.toggleModal("editLegacySystem-new")}>
                                <i className='fa fa-plus' aria-hidden="true" />
                                <UncontrolledTooltip target={`addLegacySystemTooltip`}>
                                    Add Legacy System
                                </UncontrolledTooltip>
                            </Button>
                            {this.state.openModal === "editLegacySystem-new" &&
                                <AddExternalSystem
                                    incidentId={this.props.incident?.id}
                                    openModal={this.state.openModal === "editLegacySystem-new"}
                                    handleClose={() => this.toggleModal("")}
                                    systems={[{ systemName: "", systemId: "" }]}
                                    isUpdate={false}
                                    refetchQuery={this.props.refetchQuery}
                                />
                            }
                        </h4>
                        <div className='info-container'>
                            <Row className='mt-2'>
                                {mondayItemId && this.props.hasPermissions?.includes("custom_can_view_import_source") && <Col xs={12}>
                                    <Label className='d-flex justify-content-between align-items-center'>
                                        Synced From Monday
                                        <a className='bos-custom-link' target="_blank" rel='noopener noreferrer' href={mondayItemId ? `https://voyagm.monday.com/boards/8042244172/views/182369218/pulses/${mondayItemId}` : "#"}>
                                            <i className='fa fa-external-link' style={{ fontSize: 15 }} />
                                        </a>
                                    </Label>
                                    <Input readOnly value={mondayRowTitle} />
                                    <br />
                                </Col>
                                }
                                {(this.props.incidentLoading && !this.props.incident) ? <Col><Skeleton count={2} height={30} /></Col> :
                                    Object.entries(externalSystems).length > 0 ? Object.entries(externalSystems).map(([systemName, systemId], index) => (
                                        <CustomInputField
                                            key={`system-${index}`}
                                            label={systemName}
                                            fieldName={`legacyId-${index}`}
                                            fieldDescription={`Legacy System ID for ${systemName}`}
                                            showCopyIcon={false}
                                            showEditIcon={!this.props.incident?.isArchived}
                                            inputType="text"
                                            error={this.state.fieldErrors?.[`legacyId-${index}`] || null}
                                            isEditing={this.state.editField === `legacyId-${index}`}
                                            isLoading={!!this.state.fieldLoading[`legacyId-${index}`]}
                                            inputValue={this.state.inputValues[`legacyId-${index}`] || systemId}
                                            currentValue={systemId || "--"}
                                            onEdit={() => this.toggleModal(`editLegacySystem-${systemName}`)}
                                            onSave={this.saveField}
                                            onChange={this.updateInput}
                                            onCancel={this.cancelEdit}
                                            renderEditingModal={() =>
                                                this.state.openModal === `editLegacySystem-${systemName}` && (
                                                    <AddExternalSystem
                                                        incidentId={this.props.incident?.id}
                                                        openModal={this.state.openModal === `editLegacySystem-${systemName}`}
                                                        handleClose={() => this.toggleModal("")}
                                                        systems={[{ systemName, systemId }]}
                                                        isUpdate={true}
                                                        refetchQuery={this.props.refetchQuery}
                                                    />
                                                )
                                            }
                                        />
                                    )) : !mondayItemId ? "No Legacy Systems Found" : null
                                }
                            </Row>
                        </div>
                    </Col>
                </Row>
                <Row className='mt-4'>
                    <Col xs="12" className="pb-2">
                        <h4>INCIDENT DAMAGES</h4>
                        <div className='info-container'>
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th style={{ fontWeight: 500 }}>#</th>
                                        {ISSUES_TABLE.map(tableHeader =>
                                            <th key={tableHeader.id} style={{ fontWeight: 500 }}>{tableHeader.name}</th>
                                        )}
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.props.incident?.incidentdamageSet?.edges?.length > 0 ? (
                                        <>
                                            {this.props.incident?.incidentdamageSet?.edges?.map((incidentDamage, i) => (
                                                <tr key={`incidentDamage__${i}`}>
                                                    <td scope="row" className="incident-listing-checkbox-wrapper">
                                                        {!this.state.selectedDamages.includes(incidentDamage.node.id) && <span className="listing-counter">{i + 1}</span>}
                                                        <span className="listing-checkbox" onClick={() => this.handleDamageSelection(incidentDamage.node.id)}>
                                                            {this.state.selectedDamages.includes(incidentDamage.node.id) ? <i className="fa fa-check-square-o" aria-hidden="true"></i> : <i className="fa fa-square-o unchecked" aria-hidden="true"></i>}
                                                        </span>
                                                    </td>
                                                    <td><small>{incidentDamage.node.damage.dateAdded ? <DatetimeRenderer datetime={incidentDamage.node.damage.dateAdded} placement="right" /> : "---"}</small></td>
                                                    <td><small>{incidentDamage.node.damage && incidentDamage.node.damage.issueCategory ? incidentDamage.node.damage.issueCategory.name : "NO CATEGORY SELECTED"}</small></td>
                                                    <td><small>{incidentDamage.node.damage.status ? incidentDamage.node.damage.status : "---"}</small></td>
                                                    <td><small>{incidentDamage.node.damage.projectedCost ? `$${incidentDamage.node.damage.projectedCost}` : "---"}</small></td>
                                                    <td><small>{this.props?.carIssueSeverityLevels?.enumValues?.find(item => item.name === incidentDamage.node.damage.severity)?.description || '---'}</small></td>
                                                    <td><small>{incidentDamage.node.damage.canPickup ? <i className="fa fa-check"></i> : <i className="fa fa-times"></i>}</small></td>
                                                    <td>
                                                        <small>
                                                            {incidentDamage.node.damage.pictures && incidentDamage.node.damage.pictures.edges && incidentDamage.node.damage.pictures.edges.length > 0 ?
                                                                <div onClick={() => this.viewPictures(incidentDamage.node.damage.pictures.edges)}>
                                                                    <i className="fa fa-file-image-o fa-lg" aria-hidden="true"></i>
                                                                    {incidentDamage.node.damage.pictures.edges.length > 1 &&
                                                                        <a className="bos-custom-link" target="_blank">
                                                                            &nbsp;&nbsp;+{incidentDamage.node.damage.pictures.edges.length - 1} more
                                                                        </a>}
                                                                </div> :
                                                                "No Pictures Found"}
                                                        </small>
                                                    </td>
                                                    <td>
                                                        <i id={"editCarIssue" + i} className="fa fa-pencil-square-o" aria-hidden="true" onClick={() => this.setState({ openModal: "editCarIssue" + i })}></i>
                                                        {this.state.openModal === "editCarIssue" + i && <CarIssueModal open={this.state.openModal === "editCarIssue" + i} isUpdate carIssue={incidentDamage.node.damage} handleClose={() => this.toggleModal("editCarIssue" + i)} refetchQuery={this.props.refetchQuery} />}
                                                        <UncontrolledTooltip target={"editCarIssue" + i}>Edit Car Issue</UncontrolledTooltip>
                                                    </td>
                                                </tr>
                                            ))}
                                        </>
                                    ) : (
                                        <tr><td colSpan="9" style={{ color: "red" }}>No Damages Found!</td></tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </Col>
                </Row>
            </div >
        )
    }
}

export default graphql(IncidentDetailQuery, {
    options: ({ id }) => ({
        variables: { incidentId: id },
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true
    }),
    props: ({ data: { incident, loading, refetch, variables, ridesharePlatformChoices, ridesharePeriodChoices, ridesharePeriodSourceChoices, responsiblePartyChoices, sourceChoices, statusChoices, reportedByChoices, carIssueSeverityLevels, incidentTypeChoices, carTotaledChoices, incidentNodeFieldDescriptions, branchOptions } }) => ({
        incident,
        incidentLoading: loading,
        variables,
        ridesharePlatformChoices,
        ridesharePeriodChoices,
        ridesharePeriodSourceChoices,
        responsiblePartyChoices,
        sourceChoices,
        statusChoices,
        reportedByChoices,
        carIssueSeverityLevels,
        incidentTypeChoices,
        carTotaledChoices,
        incidentNodeFieldDescriptions,
        branchOptions,
        refetchQuery: () => {
            return refetch({
                query: IncidentDetailQuery,
                variables: {
                    ...variables,
                },
                updateQuery: (previousResult, { fetchMoreResult }) => {
                    return { incident: fetchMoreResult.incident }
                },
            })
        },
    }),
})(graphql(HasPermissionsQuery, {
    options: () => ({
        variables: { userPermissions: ["custom_can_edit_car_on_hold", "custom_can_view_import_source", "custom_can_change_incident_branch"] },
    }),
    props: ({ data: { hasPermissions, loading, variables } }) => ({
        hasPermissions,
        loading,
        variables,
    }),
})(withApolloClient(OverviewTab)))
